export const getTokenFromStorage = (locationKey = 'auth') => {
  const auth = JSON.parse(localStorage[locationKey] || '{}')

  return auth.token
}
